'use client';
import { Session } from '@pickleballinc/lib/session';
import { Button } from '@pickleballinc/react-ui';
import { useEffect, useState } from 'react';

import { PlayerStatus } from '@/modules/players/v2/tabs/stats/PlayerStatus';
import { PlayerData } from '@/types/players.types';
import { getLoginUrl } from '@/utils/helpers/getLoginUrl';

type PlayerRatingsProps = {
  playerData: PlayerData | undefined;
  user?: Session;
};

export const PlayerRatings = ({ playerData, user }: PlayerRatingsProps) => {
  const [baseURL, setBaseURL] = useState('');

  useEffect(() => {
    setBaseURL(window.location.href);
  }, []);

  return (
    <div className='relative'>
      <div className='relative mb-12 flex w-full flex-col rounded-xl border bg-white shadow-md'>
        <div className='flex flex-col px-4 sm:flex-row sm:justify-around sm:p-6'>
          <PlayerStatus
            status={playerData?.systemActiveDoublesRating}
            title='Doubles'
            statusSize='md'
            user={user}
            proLevel={playerData?.proLevelId}
          />
          <div className='border-b sm:border-l' />
          <PlayerStatus
            status={playerData?.systemActiveSinglesRating}
            title='Singles'
            statusSize='md'
            user={user}
            proLevel={playerData?.proLevelId}
          />
          <div className='border-b sm:border-l' />
          <PlayerStatus
            status={playerData?.systemActiveSkinnySinglesRating}
            title='Skinny Singles'
            statusSize='md'
            user={user}
            proLevel={playerData?.proLevelId}
          />
        </div>

        {!user?.token && playerData?.proLevelId !== 5 && (
          <div className='absolute inset-0 m-2 flex items-center justify-center backdrop-blur-sm'>
            <a href={getLoginUrl(baseURL)} rel='nofollow' aria-label='Link to login or sign up'>
              <Button variant='primary' size='sm' className='bg-experiment'>
                Login or Sign Up
              </Button>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
